<template lang="pug">
    v-menu(
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="date"
        transition="scale-transition"
        offset-y
        min-width="290px"
    )
        template(v-slot:activator="{ on }")
            v-text-field(
                v-model="date"
                :label="label ? label : 'Data'"
                :filled="filled ? true : false"
                :outlined="outlined ? true : false"
                :dense="dense ? true : false"
                v-on="on"
                :color="color?color:'#1AA0DA'"
                :rules="rules"
            )
        v-date-picker(
            v-model="date"
            scrollable
            :color="color?color:'#1AA0DA'"
            locale="pl-PL"
            first-day-of-week="1"
        )
            v-spacer
            v-btn(text color="red" @click="menu = false") Anuluj
            v-btn(text color="green" @click="$refs.menu.save(date)") Ok

</template>

<script>
import moment from "moment";

export default {
    name: "enl-date-picker",

    props: {
        label: {
            required: false
        },
        value: {
            required: false
        },
        color: {
            required: false
        },
        filled: {
            required: false,
            type: Boolean
        },
        outlined: {
            required: false,
            type: Boolean
        },
        dense: {
            required: false,
            type: Boolean
        },
        rules: {
            required: false,
            type: Array
        }
    },

    data() {
        return {
            menu: false,
            date: null
        };
    },

    watch: {
        date(val) {
            if (val) {
                this.$emit("input", this.getTimestamp(val));
            }
        },

        value: {
            immediate: true,
            handler: function(val) {
                this.date = this.getDate(val);
            }
        }
    },

    methods: {
        getTimestamp(date) {
            return new moment(date).valueOf();
        },
        getDate(timestamp) {
            if (!timestamp) {
                return null;
            } else {
                const now = moment(timestamp);
                now.add(12, "h");
                return now.format("YYYY-MM-DD");
            }
        }
    }
};
</script>
